class PipeDriveService {
    constructor($http, $q) {
        let self = this;

        this.getNotes = function(evaluation) {
            return $http({
                method: 'GET',
                url: `https://api.pipedrive.com/v1/notes?deal_id=${evaluation.pipedriveDealId}&start=0&api_token=77b1c55859ad1cefbc4223ce1cd2056d8cb62196`
            }).then((res => res.data.data), (error) => $q.reject(error));
        };

        this.sendNote = function(data) {
            return $http({
                method: 'POST',
                url: 'https://api.pipedrive.com/v1/notes?api_token=77b1c55859ad1cefbc4223ce1cd2056d8cb62196',
                data: data
            }).then((res => res.data), (error) => $q.reject(error));
        };

        this.getPipeDrivesByDeal = function(deal) {
            return $http({
                method: 'GET',
                url: `https://api.pipedrive.com/v1/deals/${deal.id}?api_token=77b1c55859ad1cefbc4223ce1cd2056d8cb62196`
            }).then((res => res.data), (error) => $q.reject(error));
        };

        this.searchPipeDrives = function(term) {
            return $http({
                method: 'GET',
                url: `https://api.pipedrive.com/v1/searchResults?term=${term}&item_type=deal&start=0&api_token=77b1c55859ad1cefbc4223ce1cd2056d8cb62196`
            }).then((res => res.data), (error) => $q.reject(error));
        };

    }
}

export default PipeDriveService;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/pipeDriveService.js